import { getCurrentInstance } from "vue";

export function useRouterCompat() {
  const internalInstance = getCurrentInstance();
  if (!internalInstance) {
    throw new Error("useRouterCompat must be called within setup.");
  }

  const proxy = internalInstance.proxy;

  return {
    router: proxy.$router,
    route: proxy.$route,
  };
}
